import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  primaryColor,
  grayColor,
  redColor,
  yellowColor,
  purpleColor,
  pinkColor,
  dangerColor,
} from 'assets/styles/jss/main';

const colorMap = {
  primaryColor,
  secondaryColor: grayColor,
  redColor,
  yellowColor,
  purpleColor,
  pinkColor,
};

const CustomCheckbox = (props) => {
  const { color, error, label, ...rest } = props;
  const checkedColor = colorMap[`${color}Color`];

  return (
    <FormControlLabel
      label={label}
      control={
        <Checkbox
          {...rest}
          sx={{
            color: error ? dangerColor : grayColor,
            '&.Mui-checked': {
              color: checkedColor,
            },
          }}
        />
      }
    />
  );
};

CustomCheckbox.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary', 'red', 'yellow', 'purple', 'pink']),
  label: PropTypes.node,
  error: PropTypes.bool,
};

CustomCheckbox.defaultProps = {
  color: 'primary',
};

export default CustomCheckbox;
